var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2083 0.875H2.95832C1.69416 0.875 0.666656 1.9025 0.666656 3.16667V16.7083C0.666656 17.9725 1.69416 19 2.95832 19H14.2083C15.4725 19 16.5 17.9725 16.5 16.7083V3.16667C16.5 1.9025 15.4725 0.875 14.2083 0.875ZM4.83332 5.66667H8.99999C9.45999 5.66667 9.83332 6.04 9.83332 6.5C9.83332 6.96 9.45999 7.33333 8.99999 7.33333H4.83332C4.37332 7.33333 3.99999 6.96 3.99999 6.5C3.99999 6.04 4.37332 5.66667 4.83332 5.66667ZM13.1667 14H4.83332C4.37332 14 3.99999 13.6267 3.99999 13.1667C3.99999 12.7067 4.37332 12.3333 4.83332 12.3333H13.1667C13.6267 12.3333 14 12.7067 14 13.1667C14 13.6267 13.6267 14 13.1667 14ZM13.1667 10.6667H4.83332C4.37332 10.6667 3.99999 10.2933 3.99999 9.83333C3.99999 9.37333 4.37332 9 4.83332 9H13.1667C13.6267 9 14 9.37333 14 9.83333C14 10.2933 13.6267 10.6667 13.1667 10.6667Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartNote);
export default __webpack_public_path__ + "static/media/cart-note.6337fef182820ac0c8806e3042522ba7.svg";
export { ForwardRef as ReactComponent };